import { Link } from '@solidjs/meta';

export function LeagueSpartan()
{

	return (<>
<Link rel='preconnect' href='https://fonts.googleapis.com'/>
<Link rel='preconnect' href='https://fonts.gstatic.com' crossorigin=''/>
<Link href='https://fonts.googleapis.com/css2?family=League+Spartan:wght@100..900&display=swap' rel='stylesheet'/>
	</>);



}

LeagueSpartan.fontFamily = '"League Spartan", sans-serif';
